export default __webpack_public_path__ + "static/media/Montserrat-Medium.214fb940.woff2";